import { useNavigate } from '@tanstack/react-router'
import { useEffect, type ReactNode } from 'react'
import AppLayout from '../components/AppLayout'
import { Alert } from '../components/ui'
import { useCurrentUser, type CurrentUser } from '../lib/session'

// Confort d'affichage, pas une securite : le serveur exige la session sur /api/*.
export default function RequireSession({
  adminOnly = false,
  children,
}: {
  adminOnly?: boolean
  children: (user: CurrentUser) => ReactNode
}) {
  const navigate = useNavigate()
  const session = useCurrentUser()
  const user = session.data ?? null

  useEffect(() => {
    if (!session.isPending && user === null) {
      void navigate({ to: '/login', replace: true })
    }
  }, [session.isPending, user, navigate])

  if (session.isPending) {
    return (
      <main className="flex min-h-screen items-center justify-center text-sm text-neutral-500">
        Chargement...
      </main>
    )
  }

  if (user === null) {
    return null
  }

  if (adminOnly && !user.isAdmin) {
    return (
      <AppLayout user={user}>
        <Alert>Cette page est reservee aux administrateurs.</Alert>
      </AppLayout>
    )
  }

  return <>{children(user)}</>
}
